export default "__VITE_ASSET__636ecb57__"